/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { DataConnectionOAuthSettingsFragmentDoc } from "../data-connection-item/DataConnectionItem.generated";
export type DataConnectionSelectItemSchemaFragment = {
  readonly __typename: "DataConnectionSchema";
  readonly connectionMetadata: {
    readonly __typename: "DataConnectionMetadata";
    readonly displayName: string;
  };
};

export type DataConnectionSelectItemFragment = {
  readonly __typename: "DataConnection";
  readonly id: c.DataConnectionId;
  readonly connectionName: string;
  readonly connectionDescription: string | null;
  readonly connectionType: c.DataConnectionType;
  readonly hasDetails: boolean;
  readonly hexId: c.HexId | null;
  readonly isDemoConnection: boolean;
  readonly demoDataConnectionId: c.DemoDataConnectionId | null;
  readonly allowWriteback: boolean;
  readonly enableSnowpark: boolean;
  readonly authenticationType: string | null;
  readonly isDefault: boolean;
  readonly isMultiDatabase: boolean;
  readonly dbtSemanticLayerVersion: Types.DbtSemanticLayerVersion | null;
  readonly hasDbtMetrics: boolean;
  readonly hasDbtProxy: boolean;
  readonly hasDbtMetadata: boolean;
  readonly lastRefreshed: c.DateTimeString | null;
  readonly dbtErrorMessages: ReadonlyArray<string> | null;
  readonly dbtMetadataError: boolean;
  readonly dbtMetadataErrorMessages: ReadonlyArray<string> | null;
  readonly dbtMetricsError: boolean;
  readonly dbtMetricsErrorMessages: ReadonlyArray<string> | null;
  readonly schemaRefreshErrorMessages: ReadonlyArray<string> | null;
  readonly useDbtJdbcDriver: boolean | null;
  readonly status: string | null;
  readonly allowAgentExternalAccess: boolean | null;
  readonly oauthSettings: {
    readonly __typename: "DataConnectionOAuthSettings";
    readonly id: c.DataConnectionOAuthSettingsId;
    readonly logicViewSetting: Types.OAuthLogicViewSetting;
    readonly publishedAppSetting: Types.OAuthPublishedAppSetting;
    readonly userScopedResultsSetting: Types.OAuthUserScopedResultsSetting;
  } | null;
  readonly passthroughOAuthInfo: {
    readonly __typename: "PassthroughOAuthInfo";
    readonly dataConnectionId: c.DataConnectionId;
    readonly dataConnectionName: string;
    readonly dataConnectionType: c.OAuthConnectionType;
    readonly oAuthConnectionId: string;
    readonly hasValidToken: boolean;
    readonly currentRole: string | null;
    readonly requiredRole: string | null;
    readonly authWithSso: boolean;
  } | null;
  readonly grants: ReadonlyArray<{
    readonly __typename: "SharedAssetGrant";
    readonly id: c.SharedAssetGrantId;
    readonly role: Types.SharedAssetRole;
    readonly holder:
      | { readonly __typename: "Group"; readonly groupId: c.GroupId }
      | {
          readonly __typename: "IntrinsicGroup";
          readonly name: string;
          readonly intrinsicGroupId: Types.IntrinsicGroupId;
        };
  }>;
  readonly sensitivitySettings: {
    readonly __typename: "DataConnectionSensitivitySettings";
    readonly sensitivity: Types.DataConnectionSensitivity;
    readonly locked: boolean;
  };
};

export const DataConnectionSelectItemSchemaFragmentDoc = /*#__PURE__*/ gql`
  fragment DataConnectionSelectItemSchemaFragment on DataConnectionSchema {
    connectionMetadata {
      displayName
    }
  }
`;
export const DataConnectionSelectItemFragmentDoc = /*#__PURE__*/ gql`
  fragment DataConnectionSelectItemFragment on DataConnection {
    id
    connectionName
    connectionDescription
    connectionType
    hasDetails
    hexId
    isDemoConnection
    demoDataConnectionId
    allowWriteback
    enableSnowpark
    authenticationType
    oauthSettings {
      id
      ...DataConnectionOAuthSettingsFragment
    }
    passthroughOAuthInfo(appSessionId: $appSessionId) {
      dataConnectionId
      dataConnectionName
      dataConnectionType
      oAuthConnectionId
      hasValidToken
      currentRole
      requiredRole
      authWithSso
    }
    isDefault
    isMultiDatabase
    dbtSemanticLayerVersion
    hasDbtMetrics
    hasDbtProxy
    hasDbtMetadata
    lastRefreshed
    dbtErrorMessages
    dbtMetadataError
    dbtMetadataErrorMessages
    dbtMetricsError
    dbtMetricsErrorMessages
    schemaRefreshErrorMessages
    useDbtJdbcDriver
    status
    grants {
      id
      role
      holder {
        ... on Group {
          groupId: id
        }
        ... on IntrinsicGroup {
          intrinsicGroupId: id
          name
        }
      }
    }
    allowAgentExternalAccess
    sensitivitySettings {
      sensitivity
      locked
    }
  }
  ${DataConnectionOAuthSettingsFragmentDoc}
`;
